import request from './../util/request'
//获取群组可配置的组件列表
export function getOrderInfo(data) {
  return request({
    url: '/v2/ods/getOdsInfo/'+data.projectId,
    method: 'post',
    data
  })
}
//分享页面根据订单请求外部平台数据
export function getOrderDataByShare(data) {
  return request({
    url: '/v2/tableShare/pub/getOdsInfoByShare/'+data.shareId,
    method: 'post',
    data
  })
}
//根据物流单号获取物流信息
export function getLogisticInfo(data) {
  return request({
    url: '/v2/logistics/getLogisticInfo',
    method: 'post',
    data
  })
}
//根据运单号获取物流
export function getLogistic(data) {
  return request({
    url: '/v2/logistics/getLogistics',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js